// extracted by mini-css-extract-plugin
export default {"toastsWrapper":"mKKnLtRYT92Lw1iPlnig","toast":"llmHTArHG8dLJrKpLwRj"};